import { useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle, X, Sparkles } from "lucide-react";
import ConsultantChat from "@/components/ConsultantChat";

export default function ChatWidget() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  if (loc.pathname.startsWith("/orcamento")) return null;

  return (
    <>
      {open && (
        <div className="fixed bottom-[calc(6rem+env(safe-area-inset-bottom))] right-4 sm:right-6 z-50 w-[calc(100vw-2rem)] sm:w-[380px] h-[560px] max-h-[calc(100dvh-7rem)] rounded-2xl border border-[#1E293B] bg-[#0B0F17] shadow-2xl shadow-black/60 flex flex-col overflow-hidden"
          data-testid="chat-widget-panel">
          <div className="h-14 px-4 flex items-center justify-between border-b border-[#1E293B] bg-[#0B0F17]">
            <div className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-full bg-[#0CDBF2] flex items-center justify-center"><Sparkles size={15} className="text-[#07090E]" /></div>
              <div>
                <div className="text-sm font-semibold leading-tight">Consultor ATP</div>
                <div className="text-[11px] text-emerald-400 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-emerald-400" /> Online agora</div>
              </div>
            </div>
            <button onClick={() => setOpen(false)} className="p-1.5 rounded-md hover:bg-white/5 text-slate-400" data-testid="chat-widget-close"><X size={18} /></button>
          </div>
          <div className="flex-1 min-h-0"><ConsultantChat compact /></div>
        </div>
      )}
      <button onClick={() => setOpen((v) => !v)} data-testid="chat-widget-toggle"
        className="fixed bottom-[calc(1.5rem+env(safe-area-inset-bottom))] right-4 sm:right-6 z-50 flex items-center gap-2 rounded-full bg-[#0CDBF2] text-[#07090E] font-semibold pl-4 pr-5 h-14 shadow-lg shadow-[#0CDBF2]/25 hover:bg-[#0ABED4] transition-transform hover:scale-[1.03]">
        {open ? <X size={20} /> : <MessageCircle size={20} />}
        <span className="text-sm">{open ? "Fechar" : "Falar com consultor"}</span>
      </button>
    </>
  );
}
